<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else class="employee">
      <app-cells>
        <h2 class="title">Salary</h2>
        <app-button @click.native="onShowAddSalaryPopup" size="small">Add salary</app-button>
      </app-cells>
      <v-client-table
        :data="table_salary.items"
        :columns="table_salary.columns"
        :options="table_salary.options"
        class="table-default"
        :class="{'table-default--loading': table_salary_preloader}"
      >
        <template #h__period><div class="table-default__left">Period</div></template>
        <template #h__created><div class="table-default__left">Created by</div></template>
        <template #h__updated><div class="table-default__left">Updated by</div></template>
        <template #period="{ row }">
          <div class="table-default__left">
            {{ dateFormatting(row.from_date) }} - {{ dateFormatting(row.to_date) }}
          </div>
        </template>
        <template #amount="{ row }">{{ row.amount.toLocaleString() }} {{ row.currency }}</template>
        <template #created="{ row }">
          <div class="table-default__left">
            <div v-if="row.created_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.created_at) }}
            </div>
          </div>
        </template>
        <template #updated="{ row }">
          <div class="table-default__left">
            <div v-if="row.updated_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.updated_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.updated_at) }}
            </div>
          </div>
        </template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowEditSalaryPopup(row)" type="button">
              <img src="@/assets/img/edit-table-icon.svg" alt="">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells>
        <h2 class="title">Benefits</h2>
        <app-button @click.native="onShowAddBenefitsPopup" size="small">Add benefit</app-button>
      </app-cells>
      <v-client-table
        :data="table_benefits.items"
        :columns="table_benefits.columns"
        :options="table_benefits.options"
        class="table-default"
        :class="{'table-default--loading': table_benefits_preloader}"
      >
        <template #h__date><div class="table-default__left">Date</div></template>
        <template #h__reason><div class="table-default__left">Reason</div></template>
        <template #h__created><div class="table-default__left">Created by</div></template>
        <template #h__updated><div class="table-default__left">Updated by</div></template>
        <template #date="{ row }">
          <div class="table-default__left">
            {{ dateFormatting(row.date) }}
          </div>
        </template>
        <template #amount="{ row }">{{ row.amount.toLocaleString() }}</template>
        <template #reason="{ row }">
          <div class="table-default__left">
            {{ row.reason }}
          </div>
        </template>
        <template #created="{ row }">
          <div class="table-default__left">
            <div v-if="row.created_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.created_at) }}
            </div>
          </div>
        </template>
        <template #updated="{ row }">
          <div class="table-default__left">
            <div v-if="row.updated_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.updated_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.updated_at) }}
            </div>
          </div>
        </template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowEditBenefitsPopup(row)" type="button">
              <img src="@/assets/img/edit-table-icon.svg" alt="">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells>
        <h2 class="title">Warnings</h2>
        <app-button @click.native="onShowAddWarningsPopup" size="small">Add warning</app-button>
      </app-cells>
      <v-client-table
        :data="table_warnings.items"
        :columns="table_warnings.columns"
        :options="table_warnings.options"
        class="table-default"
        :class="{'table-default--loading': table_warnings_preloader}"
      >
        <template #h__date><div class="table-default__left">Date</div></template>
        <template #h__reason><div class="table-default__left">Reason</div></template>
        <template #h__created><div class="table-default__left">Created by</div></template>
        <template #h__updated><div class="table-default__left">Updated by</div></template>
        <template #date="{ row }">
          <div class="table-default__left">
            {{ dateFormatting(row.date) }}
          </div>
        </template>
        <template #penalty="{ row }">{{ row.fee ? row.fee.toLocaleString() : '-' }}</template>
        <template #reason="{ row }">
          <div class="table-default__left">
            {{ row.reason }}
          </div>
        </template>
        <template #created="{ row }">
          <div class="table-default__left">
            <div v-if="row.created_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.created_at) }}
            </div>
          </div>
        </template>
        <template #updated="{ row }">
          <div class="table-default__left">
            <div v-if="row.updated_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.updated_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.updated_at) }}
            </div>
          </div>
        </template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowEditWarningsPopup(row)" type="button">
              <img src="@/assets/img/edit-table-icon.svg" alt="">
            </button>
          </div>
        </template>
      </v-client-table>
    </template>
    <modal
      name="salary"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('salary')" class="popup__close" type="button"></button>
        <div class="popup__title">
          {{ is_salary_add ? 'Add salary' : 'Update salary' }}
        </div>
        <div class="popup__body">
          <form @submit.prevent="onCheckSalaryForm">
            <app-form-group label="From" required>
              <app-date-picker
                v-model="form_salary.from_date"
                placeholder="From"
                :error="$v.form_salary.from_date.$error"
              />
              <template #error>
                <div v-if="$v.form_salary.from_date.$dirty && !$v.form_salary.from_date.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="To" required>
              <app-date-picker
                v-model="form_salary.to_date"
                placeholder="From"
                :error="$v.form_salary.to_date.$error"
              />
              <template #error>
                <div v-if="$v.form_salary.to_date.$dirty && !$v.form_salary.to_date.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Currency" required>
              <app-select
                v-model="form_salary.currency"
                :options="currency_options"
                :clearable="false"
                placeholder="Currency"
                :error="$v.form_salary.currency.$error"
              />
              <template #error>
                <div v-if="$v.form_salary.currency.$dirty && !$v.form_salary.currency.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Amount" label-for="salary_amount" required>
              <app-fin-number
                v-model="form_salary.amount"
                id="salary_amount"
                min="0"
                placeholder="0"
                name="salary_amount"
                :error="$v.form_salary.amount.$error"
              />
              <template #error>
                <div v-if="$v.form_salary.amount.$dirty && !$v.form_salary.amount.required">
                  Required field
                </div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submit_salary" :disabled="$v.form_salary.$error">
                {{ is_salary_add ? 'Add' : 'Save' }}
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="benefits"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('benefits')" class="popup__close" type="button"></button>
        <div class="popup__title">
          {{ is_benefit_add ? 'Add benefit' : 'Update benefit' }}
        </div>
        <div class="popup__body">
          <form @submit.prevent="onCheckBenefitsForm">
            <app-form-group label="Date" required>
              <app-date-picker
                v-model="form_benefits.date"
                placeholder="From"
                :error="$v.form_benefits.date.$error"
              />
              <template #error>
                <div v-if="$v.form_benefits.date.$dirty && !$v.form_benefits.date.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Amount" label-for="benefits_amount" required>
              <app-fin-number
                v-model="form_benefits.amount"
                id="benefits_amount"
                min="0"
                placeholder="0"
                name="benefits_amount"
                :error="$v.form_benefits.amount.$error"
              />
              <template #error>
                <div v-if="$v.form_benefits.amount.$dirty && !$v.form_benefits.amount.required">
                  Required field
                </div>
              </template>
            </app-form-group>
            <app-form-group label="Reason" label-for="reason" required>
              <app-textarea
                v-model="form_benefits.reason"
                id="reason"
                placeholder="Reason"
                :error="$v.form_benefits.reason.$error"
              />
              <template #error>
                <div v-if="$v.form_benefits.reason.$dirty && !$v.form_benefits.reason.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submit_benefits" :disabled="$v.form_benefits.$error">
                {{ is_benefit_add ? 'Add' : 'Save' }}
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="warnings"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('warnings')" class="popup__close" type="button"></button>
        <div class="popup__title">
          {{ is_warning_add ? 'Add warning' : 'Update warning' }}
        </div>
        <div class="popup__body">
          <form @submit.prevent="onCheckWarningsForm">
            <app-form-group label="Date" required>
              <app-date-picker
                v-model="form_warnings.date"
                placeholder="From"
                :error="$v.form_warnings.date.$error"
              />
              <template #error>
                <div v-if="$v.form_warnings.date.$dirty && !$v.form_warnings.date.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Penalty" label-for="penalty">
              <app-input
                v-model="form_warnings.fee"
                id="penalty"
                type="number"
                min="0"
                placeholder="0"
                name="penalty"
              />
            </app-form-group>
            <app-form-group label="Reason" label-for="reason" required>
              <app-textarea
                v-model="form_warnings.reason"
                id="reason"
                placeholder="Reason"
                :error="$v.form_warnings.reason.$error"
              />
              <template #error>
                <div v-if="$v.form_warnings.reason.$dirty && !$v.form_warnings.reason.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submit_warnings" :disabled="$v.form_warnings.$error">
                {{ is_warning_add ? 'Add' : 'Save' }}
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getCurrencyList,
  getEmployeesUTTBenefitsList,
  getEmployeesUTTSalaryList,
  getEmployeesUTTWarningsList,
  patchEmployeesUTTBenefit,
  patchEmployeesUTTSalary,
  patchEmployeesUTTWarning,
  postEmployeesUTTBenefit,
  postEmployeesUTTSalary,
  postEmployeesUTTWarning,
} from '@/http'
import { required } from 'vuelidate/lib/validators'
import { format, parseISO } from 'date-fns'

export default {
  name:'EmployeeUTT',
  data() {
    return {
      is_loaded: false,
      table_salary_preloader: false,
      is_salary_add: true,
      form_salary: {},
      table_salary: {
        items: [],
        columns: ['period', 'amount', 'created', 'updated', 'controls'],
        options: {
          headings: {
            period: 'Period',
            amount: 'Amount',
            created: 'Created by',
            updated: 'Updated by',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_benefits_preloader: false,
      is_benefit_add: true,
      form_benefits: {},
      table_benefits: {
        items: [],
        columns: ['date', 'amount', 'reason', 'created', 'updated', 'controls'],
        options: {
          headings: {
            date: 'Date',
            amount: 'Amount',
            reason: 'Reason',
            created: 'Created by',
            updated: 'Updated by',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_warnings_preloader: false,
      is_warning_add: true,
      form_warnings: {},
      table_warnings: {
        items: [],
        columns: ['date', 'penalty', 'reason', 'created', 'updated', 'controls'],
        options: {
          headings: {
            date: 'Date',
            penalty: 'Penalty',
            reason: 'Reason',
            created: 'Created by',
            updated: 'Updated by',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      currency_options: [],
    }
  },
  validations: {
    form_salary: {
      from_date: { required },
      to_date: { required },
      currency: { required },
      amount: { required },
    },
    form_benefits: {
      date: { required },
      amount: { required },
      reason: { required },
    },
    form_warnings: {
      date: { required },
      reason: { required },
    },
  },
  created() {
    Promise.all([
      getEmployeesUTTSalaryList(this.$route.params.id),
      getEmployeesUTTBenefitsList({ employee: this.$route.params.id }),
      getEmployeesUTTWarningsList({ employee: this.$route.params.id }),
      getCurrencyList()
    ])
      .then(res => {
        this.table_salary.items = res[0].data
        this.table_benefits.items = res[1].data
        this.table_warnings.items = res[2].data
        this.currency_options = res[3].data
        this.is_loaded = true
      })
  },
  methods: {
    fetchSalaryItems() {
      this.table_salary_preloader = true
      getEmployeesUTTSalaryList(this.$route.params.id)
        .then(res => {
          this.table_salary.items = res.data
          this.table_salary_preloader = false
        })
    },
    fetchBenefitsItems() {
      this.table_benefits_preloader = true
      getEmployeesUTTBenefitsList({ employee: this.$route.params.id })
        .then(res => {
          this.table_benefits.items = res.data
          this.table_benefits_preloader = false
        })
    },
    fetchWarningsItems() {
      this.table_warnings_preloader = true
      getEmployeesUTTWarningsList({ employee: this.$route.params.id })
        .then(res => {
          this.table_warnings.items = res.data
          this.table_warnings_preloader = false
        })
    },
    onShowAddSalaryPopup() {
      this.is_salary_add = true
      this.form_salary = {}
      this.$v.form_salary.$reset()
      this.$modal.show('salary')
    },
    onShowAddBenefitsPopup() {
      this.is_benefit_add = true
      this.form_benefits = {}
      this.$v.form_benefits.$reset()
      this.$modal.show('benefits')
    },
    onShowAddWarningsPopup() {
      this.is_warning_add = true
      this.form_warnings = {}
      this.$v.form_warnings.$reset()
      this.$modal.show('warnings')
    },
    onShowEditSalaryPopup(row) {
      this.is_salary_add = false
      this.form_salary = { ...row }
      this.$v.form_salary.$reset()
      this.$modal.show('salary')
    },
    onShowEditBenefitsPopup(row) {
      this.is_benefit_add = false
      this.form_benefits = { ...row }
      this.$v.form_benefits.$reset()
      this.$modal.show('benefits')
    },
    onShowEditWarningsPopup(row) {
      this.is_warning_add = false
      this.form_warnings = { ...row }
      this.$v.form_warnings.$reset()
      this.$modal.show('warnings')
    },
    onCheckSalaryForm() {
      this.$v.form_salary.$touch()
      if (this.$v.form_salary.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendSalaryForm()
      }
    },
    sendSalaryForm() {
      this.$refs.submit_salary.preload = true
      if (this.is_salary_add) {
        postEmployeesUTTSalary(this.$route.params.id, this.normalizeSalaryForm())
          .finally(() => { this.$refs.submit_salary.preload = false })
          .then(() => {
            this.fetchSalaryItems()
            this.$modal.hide('salary')
            this.$notify({
              type: 'success',
              title: 'Salary added',
            })
          })
      } else {
        patchEmployeesUTTSalary(this.$route.params.id, this.form_salary.id, this.normalizeSalaryForm())
          .finally(() => { this.$refs.submit_salary.preload = false })
          .then(() => {
            this.fetchSalaryItems()
            this.$modal.hide('salary')
            this.$notify({
              type: 'success',
              title: 'Salary saved',
            })
          })
      }
    },
    normalizeSalaryForm() {
      const normalizedForm = { ...this.form_salary }

      normalizedForm.currency = normalizedForm.currency.code
      return normalizedForm
    },
    onCheckBenefitsForm() {
      this.$v.form_benefits.$touch()
      if (this.$v.form_benefits.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendBenefitsForm()
      }
    },
    sendBenefitsForm() {
      this.$refs.submit_benefits.preload = true
      if (this.is_benefit_add) {
        postEmployeesUTTBenefit(this.normalizeBenefitsForm())
          .finally(() => { this.$refs.submit_benefits.preload = false })
          .then(() => {
            this.fetchBenefitsItems()
            this.$modal.hide('benefits')
            this.$notify({
              type: 'success',
              title: 'Benefit added',
            })
          })
      } else {
        patchEmployeesUTTBenefit(this.form_benefits.id, this.normalizeBenefitsForm())
          .finally(() => { this.$refs.submit_benefits.preload = false })
          .then(() => {
            this.fetchBenefitsItems()
            this.$modal.hide('benefits')
            this.$notify({
              type: 'success',
              title: 'Benefit saved',
            })
          })
      }
    },
    normalizeBenefitsForm() {
      const normalizedForm = { ...this.form_benefits }

      normalizedForm.employee = +this.$route.params.id
      return normalizedForm
    },
    onCheckWarningsForm() {
      this.$v.form_warnings.$touch()
      if (this.$v.form_warnings.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendWarningsForm()
      }
    },
    sendWarningsForm() {
      this.$refs.submit_warnings.preload = true
      if (this.is_benefit_add) {
        postEmployeesUTTWarning(this.normalizeWarningsForm())
          .finally(() => { this.$refs.submit_warnings.preload = false })
          .then(() => {
            this.fetchWarningsItems()
            this.$modal.hide('warnings')
            this.$notify({
              type: 'success',
              title: 'Warning added',
            })
          })
      } else {
        patchEmployeesUTTWarning(this.form_warnings.id, this.normalizeWarningsForm())
          .finally(() => { this.$refs.submit_warnings.preload = false })
          .then(() => {
            this.fetchWarningsItems()
            this.$modal.hide('warnings')
            this.$notify({
              type: 'success',
              title: 'Warning saved',
            })
          })
      }
    },
    normalizeWarningsForm() {
      const normalizedForm = { ...this.form_warnings }

      normalizedForm.employee = +this.$route.params.id
      return normalizedForm
    },
    dateFormatting(date) {
      if (!date) return '-'
      return format(parseISO(date), 'dd MMMM yyyy')
    },
    formatDateTime(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMMM yyyy HH:mm')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
